import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GenerateQrisComponent } from './generate-qris.component';

const routes: Routes = [
  { path: '', component: GenerateQrisComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GenerateQrisRoutingModule { }
